export const environment = {
    production: false,
    baseUrl: 'https://message-rails-api.herokuapp.com/',
    date:"02-03-2021"
  };
